import { LOCALE } from "../properties/Locale";

export const Enumerations = {
  AppEntryType: {
    TEMPORARY_TRAFFIC_CHANGE: "TEMPORARY_TRAFFIC_CHANGE",
    PERMANENT_TRAFFIC_CHANGE: "PERMANENT_TRAFFIC_CHANGE",
  },
  AppEntryTypeDisplay: {
    TEMPORARY_TRAFFIC_CHANGE: LOCALE.temporaryTrafficChange,
    PERMANENT_TRAFFIC_CHANGE: LOCALE.permanentTrafficChange,
  },
  AppEntryStatus: {
    NEW: "Ново",
    PENDING_PAYMENT: "Чека на уплата",
    SUBMITTED: "Поднесено за обработка",
    REJECTED: "Одбиено",
    PROCESSING: "Во обработка",
    CORRECTION: "Потребна е корекција",
    FOR_APPROVAL: "Генерирање барања за согласност",
    ADDITIONAL_CORRECTION: "Потребна е дополнителна корекција",
    INSTITUTIONS_REVIEW: "Барање согласност од институции",
    INSTITUTION_DECISION: "Одлука од институции",
    FINAL_DECISION_SIGNING: "Потпишување на конечна одлука",
    DONE: "Барањето е завршено",
    CANCELED: "Барањето е одбиено",
  },
  AppEntryStatusActions: {
    NEW: "Ново",
    PENDING_PAYMENT: "Чека на уплата",
    SUBMITTED: "Поднесено за обработка",
    REJECTED: "Одбиј барање",
    PROCESSING: "Во обработка",
    CORRECTION: "Потребна е корекција",
    FOR_APPROVAL: "Генерирање барања за согласност",
    ADDITIONAL_CORRECTION: "Потребна е дополнителна корекција",
    INSTITUTIONS_REVIEW: "Барање согласност од институции",
    INSTITUTION_DECISION: "Одлука од институции",
    FINAL_DECISION_SIGNING: "Потпишување на конечна одлука",
    DONE: "Барањето е завршено",
    CANCELED: "Барањето е одбиено",
  },
  AppReviewStatus: {
    PENDING: "Примено барање",
    PROCESSING: "Во обработка (доделен)",
    APPROVED: "Одобрено",
    REJECTED: "Одбиено",
    WAITING_FOR_SIGNATURE: "Чека на потпис",
    CANCELED: "Повлечено/Откажано",
  },
  DocumentType: {
    URBAN_PLANING_PROJECT_PDF: "Урбанистички проект PDF",
    URBAN_PLANING_PROJECT_DWG: "Урбанистички проект DWG",
    TRAFFIC_ENGINEERING_PROJECT_PDF: "Сообраќаен проект PDF",
    TRAFFIC_ENGINEERING_PROJECT_DWG: "Сообраќаен проект DWG",
    POWER_OF_ATTORNEY: "Полномошно овластување",
    PROOF_OF_PAYMENT: "Уплатница",
    PROJECT_REVISION: "Ревизија",
    DECISION_MVR: "Одлука од МВР (чека на потпис)",
    DECISION_JPDP: "Одлука од ЈПДП (чека на потпис)",
    DECISION_MVR_SIGNED: "Одлука од МВР (потпишана)",
    DECISION_JPDP_SIGNED: "Одлука од ЈПДП (потпишана)",
    TRAFFIC_CHANGE_REQUEST:
      "Барање за согласност за измена на режим на сообраќај",
    REQ_CANCELLATION_DOC: "Откажување на барање",
  },
};
